export default "__VITE_ASSET__9ae39d35__"